import Script from 'next/script';

import { getENV } from '../../utils/env';

export const BazaarVoiceLegacy = () => {
    const locale = getENV('NEXT_PUBLIC_LOCALE');
    const scriptLocale = locale.replace('-', '_');
    const clientName = locale === 'en-CA' ? 'petsmart-canada' : 'petsmart';
    const environment = getENV('NEXT_PUBLIC_BV_ENVIRONMENT');

    return (
        <Script
            async
            id="bazaar-voice"
            data-testid="bv-script"
            src={`https://apps.bazaarvoice.com/deployments/${clientName}/main_site/${environment}/${scriptLocale}/bv.js`}
        />
    );
};
